<video width="100%" loop autoplay>
  <source [src]="videoUrl" type="video/mp4" />
  Your browser does not support the video tag.
</video>
